import * as _ from 'underscore';

export class PortalService {

    config: Object;
    auth: Object;
    name: string;
    alias: string;
    portal: string;
    price: string;
    pkService: number;
    pkPortal: number;
    pkCamp: number;
    type: string;
    active: boolean;
    external: boolean;

    campName: string;
    campType: string;

    constructor(portalServiceData: Object){
        this.config = portalServiceData['config'];
        this.auth = portalServiceData['auth'];
        this.name = portalServiceData['name'];
        this.alias = portalServiceData['alias'];
        this.portal = portalServiceData['portal'];
        this.price = portalServiceData['price'];
        this.pkService = portalServiceData['service_pk'];
        this.pkPortal = portalServiceData['portal_pk'];
        this.type = portalServiceData['type'];
        this.active = portalServiceData['active'];
        this.external = portalServiceData['external'];
        this.pkCamp = portalServiceData.hasOwnProperty('pk_camp') ? portalServiceData['pk_camp'] : null
        this.campName = portalServiceData.hasOwnProperty('camp_name') ? portalServiceData['camp_name'] : null
        this.campType = portalServiceData.hasOwnProperty('camp_type') ? portalServiceData['camp_type'] : null
    }

    getCallRangeAllowed(): Object {
        return this.config['call_range_allowed'];
    }

    hasCallRangeAllowed(): boolean{
        return this.config.hasOwnProperty('call_range_allowed') && _.isObject(this.config['call_range_allowed']);
    }

    getCallRequeueTimeRanges(): Array<Object> {
        return this.config['call_requeue_time_ranges'];
    }

    hasCallRequeueTimeRanges(): boolean {
        return this.config.hasOwnProperty('call_requeue_time_ranges') && _.isArray(this.config['call_requeue_time_ranges']);
    }

    getHoursToAddOutOfRange(): Object {
        return this.config['hours_to_add_out_of_range'];
    }

    getDaysAllowedHours(): Array<Object> {
        return this.config['days_allowed_hours'];
    }

    hasHoursToAddOutOfRange(): boolean {
        return this.config.hasOwnProperty('hours_to_add_out_of_range') && _.isObject(this.config['hours_to_add_out_of_range']);
    }

    hasStatusRequeue(): boolean {
        return this.config.hasOwnProperty('status_requeue') && _.isArray(this.config['status_requeue']);
    }

    hasWeekDaysAllowed(): boolean {
        return this.config.hasOwnProperty('week_days_allowed') && _.isArray(this.config['week_days_allowed']);
    }

    hasDaysAllowedHours(): boolean {
        return this.config.hasOwnProperty('days_allowed_hours') && _.isArray(this.config['days_allowed_hours']);
    }

    hasHoursRangeTimezone(): boolean {
      return this.config.hasOwnProperty('hours_range_timezone') && !_.isEmpty(this.config['hours_range_timezone']);
    }

    getExternalCallback(): Object {
        return (this.config.hasOwnProperty('external_callback_options'))
            ? this.config['external_callback_options']
            : {}
        ;
    }

    getPkService(){
        return this.pkService;
    }

    getPkPortal(){
        return this.pkPortal;
    }

    getUrl(){
        return this.getConfigKey('url', '');
    }

    getUrlLogin(){
        return this.getConfigKey('url_login', '');
    }

    isCampService(): boolean {
        return (this.pkCamp > 0);
    }

    getConfigKey(key: string, defaultValue?: any) {
        return this.config.hasOwnProperty(key) ? this.config[key] : defaultValue;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/model/PortalService.ts